export class Highlight {
  _id?: string;
  name: string = '';
  icon: string = '';
  position: number = 0;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/highlight.model.ts